/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {Currency} from "./currency.zod";
import {Language} from "./language.zod";
import {OfferContent} from "./offerContent.zod";

export const OpenCustomerOfferRequest = zod.object({
  language: Language,
  currency: Currency,
  content: OfferContent,
});

export type OpenCustomerOfferRequest = zod.input<typeof OpenCustomerOfferRequest>;
export type OpenCustomerOfferRequestOutput = zod.output<typeof OpenCustomerOfferRequest>;
